export const zoomUnlocked = 'minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no'
const zoomLocked = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'

export default function lockScreenZoom(locked: boolean) {
  const viewport = document.querySelector('meta[name=viewport]')
  viewport.setAttribute('content', locked ? zoomLocked : zoomUnlocked)
}
